import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'
import 'Components/nurikae/client_search_modal/component'

import './images/logo.png'
import './images/hamburger_menu.svg'
import './images/close.svg'
import './images/building.svg'
import './images/magnifying_glass.svg'
import './images/speech_bubble.svg'
import './images/arrow_right.svg'
import './images/nurikaeru.svg'
import './images/header_search_icon.svg'
import './images/header_search_icon.svg'
import './images/beginner.svg'
import './images/logo.webp'

const openHeaderMenuTablet = () => {
  // セレクタ定義
  const ROOT_TARGET_SELECTOR = '.js-openHeaderMenu-tablet-root-target'
  const OPEN_BUTTON_TRIGGER_SELECTOR = '.js-openHeaderMenu-tablet-openButton-trigger'
  const CLOSE_BUTTON_TRIGGER_SELECTOR = '.js-openHeaderMenu-tablet-closeButton-trigger'

  // 表示状態のクラス定義
  const OPEN_CLASS_NAME = 'header-sp--open'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $openButtonTrigger = $(root).find(OPEN_BUTTON_TRIGGER_SELECTOR)
    const $closeButtonTrigger = $(root).find(CLOSE_BUTTON_TRIGGER_SELECTOR)
    const $menuTarget = $('.js-openHeaderMenu-tablet-menu-target')
    $openButtonTrigger.on('click', () => {
      // スクロール位置を一番上にする
      window.scrollTo(0, 0)

      // 画面ロック
      $('body').css('overflow', 'hidden')

      // メニューの表示処理
      $(root).addClass(OPEN_CLASS_NAME)
      $menuTarget.show()
    })

    $closeButtonTrigger.on('click', () => {
      // スクロール位置を一番上にする
      window.scrollTo(0, 0)

      // 画面ロック解除
      $('body').css('overflow', '')

      // メニューの表示処理
      $(root).removeClass(OPEN_CLASS_NAME)
      $menuTarget.slideUp('fast')
    })
  })
}

const openHeaderMenuSp = () => {
  // セレクタ定義
  const ROOT_TARGET_SELECTOR = '.js-openHeaderMenu-sp-root-target'
  const OPEN_BUTTON_TRIGGER_SELECTOR = '.js-openHeaderMenu-sp-openButton-trigger'
  const CLOSE_BUTTON_TRIGGER_SELECTOR = '.js-openHeaderMenu-sp-closeButton-trigger'

  // 表示状態のクラス定義
  const OPEN_CLASS_NAME = 'header-sp--open'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $openButtonTrigger = $(root).find(OPEN_BUTTON_TRIGGER_SELECTOR)
    const $closeButtonTrigger = $(root).find(CLOSE_BUTTON_TRIGGER_SELECTOR)
    const $menuTarget = $('.js-openHeaderMenu-sp-menu-target')

    $openButtonTrigger.on('click', () => {
      // スクロール位置を一番上にする
      window.scrollTo(0, 0)

      // 画面ロック
      $('body').css('overflow', 'hidden')

      // メニューの表示処理
      $(root).addClass(OPEN_CLASS_NAME)
      $menuTarget.show()
    })

    $closeButtonTrigger.on('click', () => {
      // スクロール位置を一番上にする
      window.scrollTo(0, 0)

      // 画面ロック解除
      $('body').css('overflow', '')

      // メニューの表示処理
      $(root).removeClass(OPEN_CLASS_NAME)
      $menuTarget.slideUp('fast')
    })
  })
}

$(() => {
  // タブレット版SPヘッダーメニューを開く処理
  openHeaderMenuTablet()
  // SP版ヘッダーメニューを開く処理
  openHeaderMenuSp()

  document.getElementsByClassName('js-ChannelIO-openWorkflow').forEach(element => {
    element.addEventListener('click', () => {
      if (typeof window.ChannelIO === 'function') {
        window.ChannelIO('openWorkflow', element.dataset.channelId)
      } else {
        // ChannelIOが埋め込まれていない環境で正しく呼ばれていることを確認するためconsole.logを仕込む
        console.log(`call ChannelIO openWorkflow ${element.dataset.channelId}`)
      }
    })
  })
})
